import { defineComponent, ref } from "vue";

export default defineComponent({
    template: `
        <div v-if="visible" class="Dialog" @click="onClick">
            <div class="Dialog__inner">
                <div v-if="visible_header" class="Dialog__bar">
                    <div v-if="title" class="Dialog__title">{{ title }}</div>

                    <button type="button" class="Dialog__close" @click="onClose">
                        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.268485 0.268485C0.626466 -0.0894952 1.20687 -0.0894952 1.56485 0.268485L5.5 4.20364L9.43515 0.268485C9.79313 -0.0894952 10.3735 -0.0894952 10.7315 0.268485C11.0895 0.626466 11.0895 1.20687 10.7315 1.56485L6.79636 5.5L10.7315 9.43515C11.0895 9.79313 11.0895 10.3735 10.7315 10.7315C10.3735 11.0895 9.79313 11.0895 9.43515 10.7315L5.5 6.79636L1.56485 10.7315C1.20687 11.0895 0.626466 11.0895 0.268485 10.7315C-0.0894952 10.3735 -0.0894952 9.79313 0.268485 9.43515L4.20364 5.5L0.268485 1.56485C-0.0894952 1.20687 -0.0894952 0.626466 0.268485 0.268485Z" fill="white"/>
                        </svg>
                    </button>
                </div>

                <div class="Dialog__body">
                    <div v-if="icon" class="Dialog__icon">
                        <svg v-if="icon == 'stop'" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.1888 0.000135068C10.2126 0.000198628 10.2358 0.000260561 10.2584 0.000260561H19.7416C19.7642 0.000260561 19.7874 0.000198628 19.8112 0.000135068C20.0702 -0.000556604 20.3963 -0.00142741 20.7172 0.0756141C20.9955 0.142422 21.2615 0.252614 21.5055 0.402144C21.7869 0.574579 22.0169 0.805779 22.1995 0.989384C22.2163 1.00625 22.2326 1.02271 22.2486 1.03868L28.9613 7.7514C28.9773 7.76738 28.9938 7.78376 29.0106 7.80054C29.1942 7.98316 29.4254 8.21312 29.5979 8.4945C29.7474 8.73851 29.8576 9.00453 29.9244 9.28281C30.0014 9.60371 30.0006 9.9298 29.9999 10.1888C29.9998 10.2125 29.9997 10.2358 29.9997 10.2584V19.7416C29.9997 19.7642 29.9998 19.7875 29.9999 19.8112C30.0006 20.0702 30.0014 20.3963 29.9244 20.7172C29.8576 20.9955 29.7474 21.2615 29.5979 21.5055C29.4254 21.7869 29.1942 22.0169 29.0106 22.1995C28.9938 22.2162 28.9773 22.2326 28.9613 22.2486L22.2486 28.9613C22.2326 28.9773 22.2162 28.9938 22.1995 29.0106C22.0169 29.1942 21.7869 29.4254 21.5055 29.5979C21.2615 29.7474 20.9955 29.8576 20.7172 29.9244C20.3963 30.0014 20.0702 30.0006 19.8112 29.9999C19.7875 29.9998 19.7642 29.9997 19.7416 29.9997H10.2584C10.2358 29.9997 10.2125 29.9998 10.1888 29.9999C9.9298 30.0006 9.60371 30.0014 9.28281 29.9244C9.00453 29.8576 8.73851 29.7474 8.4945 29.5979C8.21312 29.4254 7.98316 29.1942 7.80054 29.0106C7.78376 28.9938 7.76738 28.9773 7.7514 28.9613L1.03868 22.2486C1.02271 22.2326 1.00625 22.2163 0.989389 22.1995C0.805781 22.0169 0.574581 21.7869 0.402144 21.5055C0.252614 21.2615 0.142422 20.9955 0.0756141 20.7172C-0.00142741 20.3963 -0.000556604 20.0702 0.000135068 19.8112C0.000198628 19.7874 0.000260561 19.7642 0.000260561 19.7416V10.2584C0.000260561 10.2358 0.000198628 10.2126 0.000135068 10.1888C-0.000556604 9.92981 -0.00142741 9.60371 0.0756141 9.28281C0.142422 9.00454 0.252614 8.73851 0.402144 8.4945C0.574579 8.21311 0.805775 7.98315 0.989382 7.80052C1.00624 7.78375 1.02271 7.76737 1.03868 7.7514L7.7514 1.03868C7.76737 1.02271 7.78375 1.00624 7.80052 0.989381C7.98315 0.805775 8.21311 0.574578 8.4945 0.402144C8.73851 0.252614 9.00454 0.142422 9.28281 0.0756141C9.60371 -0.00142741 9.92981 -0.000556604 10.1888 0.000135068ZM9.92582 2.73077C9.92266 2.73092 9.91965 2.73216 9.91731 2.7343C9.86942 2.778 9.80615 2.84081 9.67984 2.96712L2.96712 9.67984C2.84081 9.80615 2.778 9.86942 2.7343 9.91731C2.73216 9.91964 2.73092 9.92266 2.73077 9.92582C2.72781 9.99058 2.72749 10.0797 2.72749 10.2584V19.7416C2.72749 19.9203 2.72781 20.0094 2.73077 20.0742C2.73092 20.0773 2.73216 20.0804 2.7343 20.0827C2.778 20.1306 2.84081 20.1939 2.96712 20.3202L9.67984 27.0329C9.80615 27.1592 9.86942 27.222 9.91731 27.2657C9.91965 27.2678 9.92266 27.2691 9.92582 27.2692C9.99058 27.2722 10.0797 27.2725 10.2584 27.2725H19.7416C19.9203 27.2725 20.0094 27.2722 20.0742 27.2692C20.0773 27.2691 20.0804 27.2678 20.0827 27.2657C20.1306 27.222 20.1939 27.1592 20.3202 27.0329L27.0329 20.3202C27.1592 20.1939 27.222 20.1306 27.2657 20.0827C27.2678 20.0804 27.2691 20.0773 27.2692 20.0742C27.2722 20.0094 27.2725 19.9203 27.2725 19.7416V10.2584C27.2725 10.0797 27.2722 9.99058 27.2692 9.92582C27.2691 9.92266 27.2678 9.91965 27.2657 9.91731C27.222 9.86942 27.1592 9.80615 27.0329 9.67984L20.3202 2.96712C20.1939 2.84081 20.1306 2.778 20.0827 2.7343C20.0804 2.73216 20.0773 2.73092 20.0742 2.73077C20.0094 2.72781 19.9203 2.72749 19.7416 2.72749H10.2584C10.0797 2.72749 9.99058 2.72781 9.92582 2.73077ZM15 8.18194C15.7531 8.18194 16.3636 8.79245 16.3636 9.54555V15C16.3636 15.7531 15.7531 16.3636 15 16.3636C14.2469 16.3636 13.6364 15.7531 13.6364 15V9.54555C13.6364 8.79245 14.2469 8.18194 15 8.18194ZM13.6364 20.4545C13.6364 19.7013 14.2469 19.0908 15 19.0908H15.0136C15.7667 19.0908 16.3773 19.7013 16.3773 20.4545C16.3773 21.2076 15.7667 21.8181 15.0136 21.8181H15C14.2469 21.8181 13.6364 21.2076 13.6364 20.4545Z" fill="#E20029"/>
                        </svg>
                    </div>

                    <div v-if="header" class="Dialog__header" v-html="header"></div>

                    <div class="Dialog__message">
                        <slot></slot>
                    </div>

                    <div class="Dialog__footer">
                        <button v-if="visible_ok" type="button" class="button button--primary button--full" @click="onOk">{{ label_ok ? label_ok : 'OK' }}</button>
                    </div>
                </div>
            </div>
        </div>
    `,

    emits: [
        'close',
        'ok',
    ],

    props: {
        title: { type: String },
        header: { type: String },

        icon: { type: String },

        visible_header: { type: Boolean, default: true },
        visible_ok: { type: Boolean },
        label_ok: { type: String },

        autoclose: { type: Boolean },
    },

    setup(props, ctx) {
        const visible = ref(false);

        function show() {
            visible.value = true;

            $('body').addClass('body--lock');
        }

        function close() {
            visible.value = false;

            $('body').removeClass('body--lock');
        }

        function onClose() {
            ctx.emit('close');

            close();
        }

        function onOk() {
            ctx.emit('ok');

            close();
        }

        function onClick(e: MouseEvent) {
            if (props.autoclose) {
                const $el = $(e.target);

                if ($el.hasClass('Dialog')) {
                    onClose();
                }
            }
        }

        return {
            visible,

            show,
            close,
            onClose,
            onOk,
            onClick,
        };
    },
});
